import { setUriPath } from "../../helpers/uri";
import {
  getLang,
  getSeed,
  getLevel,
  getSecret,
  getNextSeed,
  getNextLevel
} from "./selectors";
import { fetchCrossword } from "./actions";

export const initUri = () => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getSeed(state);
  const level = getLevel(state);

  if (!seed || !level) {
    return dispatch(fetchCrossword(lang, seed, level)).then(() =>
      dispatch(setUriState())
    );
  }

  return dispatch(setUriState());
};

export const setUriState = () => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getSeed(state);
  const level = getLevel(state);
  const secret = getSecret(state);

  return setUriPath(lang, seed, level, btoa(secret));
};

export const regenerate = () => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getNextSeed(state) || undefined;
  const level = getNextLevel(state) || getLevel(state);
  const secret = getSecret(state);

  return dispatch(fetchCrossword(lang, seed, level, secret)).then(() =>
    dispatch(setUriState())
  );
};

export const setNextSeed = () => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getNextSeed(state);
  const level = getLevel(state);
  const secret = "";

  return setUriPath(lang, seed, level, secret, true);
};

export const setNextLevel = () => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getNextSeed(state);
  const level = getNextLevel(state);
  const secret = "";

  return setUriPath(lang, seed, level, secret, true);
};

export const setLang = lang => (dispatch, getState) => {
  const state = getState();
  const seed = getSeed(state);
  const level = getLevel(state);
  const secret = "";

  return setUriPath(lang, seed, level, secret, true);
};

export const setLevel = level => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getSeed(state);
  const secret = "";

  return setUriPath(lang, seed, level, secret, true);
};

export const setSecret = secret => (dispatch, getState) => {
  const state = getState();
  const lang = getLang(state);
  const seed = getSeed(state);
  const level = getLevel(state);

  return setUriPath(lang, seed, level, btoa(secret.toUpperCase()), true);
};



// WEBPACK FOOTER //
// ./src/reducers/crossword/uriActions.js